import { createContext, useContext } from 'react';
import * as React from 'react';

export interface AmplitudeMetadata {
  [key: string]: any;
}

// Will always be initialised by the provider below, so force casting is fine
const AmplitudeMetadataContext = createContext<AmplitudeMetadata>({} as AmplitudeMetadata);

export function useAmplitudeMetadata() {
  return useContext(AmplitudeMetadataContext);
}

interface AmplitudeMetadataContextProviderProps {
  metadata: Record<string, any>;
}

export const AmplitudeMetadataContextProvider: React.FC<AmplitudeMetadataContextProviderProps> = ({
  children,
  metadata,
}) => <AmplitudeMetadataContext.Provider value={metadata}>{children}</AmplitudeMetadataContext.Provider>;
